import apiFetch from '../../../utils/apiFetch';
import { speciesRevision } from '../../../shared/rules/speciesResources.mjs';

/**
 * Spends one use of a species feature on the server (which also spends the Bonus Action on your combat turn and starts
 * its timed effect). `requests` keeps one identity per feature and revision, so a retry replays instead of spending twice.
 */
/**
 * Giant Ancestry on a hit: the server spends the use (and applies Frost's or Hill's effect) for this attack, answering
 * in the hit-feature claim shape so a refusal only drops the option.
 */
export const claimGiantAncestry = async (characterId, claim) => {
  const response = await apiFetch(`/characters/${encodeURIComponent(characterId)}/species/giant-ancestry/on-hit`, {
    method: 'POST', headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ resolutionId: claim.resolutionId, targetId: claim.targetId, turnSequence: claim.turnSequence }),
  });
  const result = await response.json().catch(() => ({}));
  if (!response.ok || !['claimed', 'replayed'].includes(result.status)) {
    return { status: 'rejected', reason: result.message || 'server-error', claimId: null, claimedByResolutionId: null };
  }
  return result;
};

/** Cloud's Jaunt: the server spends the Bonus Action and a use and teleports the token to the chosen space. */
export const spendCloudsJaunt = async (characterId, { eventId, placement }) => {
  const response = await apiFetch(`/characters/${encodeURIComponent(characterId)}/species/clouds-jaunt`, {
    method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ eventId, placement }),
  });
  const result = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(result.message || "Cloud's Jaunt could not be saved.");
  return result;
};

export const spendSpeciesUse = async (characterId, form, featureId, requests = {}) => {
  const revision = speciesRevision(form);
  if (requests[featureId]?.revision !== revision) {
    requests[featureId] = { featureId, revision, eventId: window.crypto?.randomUUID?.() || `species-${Date.now()}-${Math.random().toString(36).slice(2)}` };
  }
  const response = await apiFetch(`/characters/${encodeURIComponent(characterId)}/species/uses`, {
    method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(requests[featureId]),
  });
  const result = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(result.message || 'The species use could not be saved.');
  if (!Number.isInteger(result.speciesResources?.revision)) throw new Error('The server did not return saved species uses.');
  delete requests[featureId];
  return result;
};
